import React, { useEffect } from 'react';
import { Modal, Form, Input, DatePicker, InputNumber, Select } from 'antd';
import { CreatePartnerRequest, Partner } from '../../model/Partner.model';
import dayjs from 'dayjs';

interface PartnerEditModalProps {
  open: boolean;
  loading: boolean;
  partner: Partner | null;
  onOk: (id: number, values: CreatePartnerRequest) => void;
  onCancel: () => void;
}

const PartnerEditModal: React.FC<PartnerEditModalProps> = ({
  open,
  loading,
  partner,
  onOk,
  onCancel,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (partner) {
      form.setFieldsValue({
        ...partner,
        registrationDate: dayjs(partner.registrationDate),
      });
    }
  }, [partner, form]);

  const handleOk = async () => {
    if (!partner) return;
    try {
      const values = await form.validateFields();
      const formattedValues: CreatePartnerRequest = {
        ...values,
        registrationDate: dayjs(values.registrationDate).format('YYYY-MM-DD'),
      };
      onOk(partner.id, formattedValues);
    } catch (error) {
      console.error('Validation failed:', error);
    }
  };

  return (
    <Modal
      title="Chỉnh sửa đối tác"
      open={open}
      onOk={handleOk}
      onCancel={onCancel}
      confirmLoading={loading}
      okText="Cập nhật"
      cancelText="Hủy"
      width={600}
    >
      <Form form={form} layout="vertical" className="mt-4">
        <Form.Item
          name="name"
          label="Tên đối tác"
          rules={[{ required: true, message: 'Vui lòng nhập tên đối tác' }]}
        >
          <Input placeholder="Nhập tên đối tác" />
        </Form.Item>

        <div className="grid grid-cols-2 gap-4">
          <Form.Item name="email" label="Email">
            <Input placeholder="Nhập email" />
          </Form.Item>

          <Form.Item name="phone" label="Số điện thoại">
            <Input placeholder="Nhập số điện thoại" />
          </Form.Item>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <Form.Item name="registrationDate" label="Ngày đăng ký">
            <DatePicker
              className="w-full"
              format="DD/MM/YYYY"
              placeholder="Chọn ngày đăng ký"
            />
          </Form.Item>
          <Form.Item name="status" label="Trạng thái">
            <Select>
              <Select.Option value="ACTIVE">Hoạt động</Select.Option>
              <Select.Option value="INACTIVE">Không hoạt động</Select.Option>
            </Select>
          </Form.Item>
        </div>

        <Form.Item name="description" label="Mô tả">
          <Input.TextArea rows={4} placeholder="Nhập mô tả" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PartnerEditModal;
